import axios from "../index"

/**
 * 查询可检索条件列表接口
 * @param params
 * @returns {*}
 */
export function listSearchParam(params) {
  return axios.get('/portal/book/listSearchParam', {params})
}

/**
 * 加入收藏
 * @param params
 * @returns {*}
 */
export function addCollection(params) {
  return axios.get('/portal/collection/addCollection', {params})
}

/**
 * 取消收藏
 * @param params
 * @returns {*}
 */
export function deleteCollectionById(params) {
  return axios.get('/portal/collection/deleteCollectionById', {params})
}

/**
 * 用户收藏列表
 * @param params
 * @returns {*}
 */
export function listCollection(params) {
  return axios.get('/portal/collection/listCollection', {params})
}
